import { CurrentGuides, ArchivedGuides } from './guides';

# How-to guides

Recruitment software providers are expected to deliver the latest and most valuable experiences to our mutual hirers within a reasonable period from when they are made generally available.
The baseline requirements for a marketplace integration are revised on a scheduled basis,
rolling up changes to the SEEK API that have been [incrementally released] since the last revision.

Our how-to guides provide instructions and timelines for adopting new revisions and working with specific features,
walking you through each change in a self-contained manner.

By contrast,
our use cases provide foundational technical knowledge about each product and its features,
and enable integration with your recruitment software from scratch.

## Current guides

<CurrentGuides />

## Archived guides

When a how-to guide is no longer in active use,
its pages are retained in an archive for troubleshooting purposes.

<ArchivedGuides />

[incrementally released]: /introduction/release-notes
